import React from 'react'
import { connect } from 'react-redux'
import {
  Label,
  Text,
  ButtonContainer,
  StatusContainer,
  StatusContent,
  IconContainer
} from '../InvoiceListItem/styles'
import Button from 'app/elements/Button'
import { formatMethod } from '../../../utils/paymentMethods'
import { Icon } from '../Icon'
/**
 * Return label based on status
 * @param {string} status
 */
const formatLabel = status => {
  switch (status) {
    case 'PENDENTE':
      return 'Fatura fechada'
    case 'AGENDADO':
      return 'Fatura fechada'
    case 'NAO_AUTORIZADO':
      return 'Fatura fechada'
    case 'NAO_COMPENSADO':
      return 'Fatura fechada'
    case 'CANCELADO':
      return 'Fatura fechada'
    case 'COMPENSADO':
      return 'Fatura paga'
    case 'AUTORIZADO':
      return 'Fatura paga'
    case 'ATRASO':
      return 'Fatura em atraso'
    default:
      return 'Fatura atual'
  }
}

const checkRequestNewBoleto = (status, paymentType, dataVencimento) => {
  if (!dataVencimento && !paymentType) {
    return false
  }

  if (
    status !== 'COMPENSADO' &&
    status !== 'EM_ABERTO' &&
    status !== 'FATURA_ATUAL' &&
    status !== 'AUTORIZADO'
  ) {
    const currentDate = new Date()

    if (paymentType === 'DEBITO_EM_CONTA') {
      let dueDate = new Date(`${dataVencimento} 23:59:59`)
      dueDate.setDate(dueDate.getDate() + 4) // 4 Dias de ataso

      return currentDate > dueDate
    }

    if (paymentType === 'CARTAO_DE_CREDITO' || paymentType === 'BOLETO') {
      const dueDate = new Date(`${dataVencimento} 23:59:59`)

      return currentDate > dueDate
    }
  }
  return false
}

const InvoiceStatus = ({
  status,
  method,
  planId,
  nsu,
  downloadTicket,
  idElemento,
  linkBoleto,
  dataVencimento,
  requestNewBoleto,
  userData,
  currentAccount
}) => (
  <StatusContainer>
    <IconContainer>
      <Icon width="62" height="50" icon={status} viewBox="0 0 102 102" />
    </IconContainer>
    <StatusContent>
      <Label>{formatLabel(status)}</Label>
      <Text status={status} id={idElemento}>
        {formatMethod(status, method)}
      </Text>
    </StatusContent>
    {linkBoleto && (
      <ButtonContainer>
        <Button
          id={`link_boleto_${nsu}`}
          secondary
          width="112px"
          lineHeight="32px"
          fontSize="14.5px"
          padding="2px"
          onClick={() => window.open(linkBoleto, '_blank')}
          text="Baixar boleto"
        />
      </ButtonContainer>
    )}
    {currentAccount &&
      !linkBoleto &&
      checkRequestNewBoleto(status, currentAccount.paymentType, dataVencimento) && (
        <ButtonContainer>
          <Button
            width="112px"
            lineHeight="32px"
            fontSize="14.5px"
            padding="2px"
            onClick={() => requestNewBoleto(userData.profile.customerId, nsu)}
            id={`solicitar_boleto_${nsu}`}
            text="Solicitar boleto"
          />
        </ButtonContainer>
      )}
  </StatusContainer>
)

const mapStateToProps = ({ reducer }) => ({
  userData: reducer.user,
  currentAccount: reducer.accountPlans.plans.find(ac => ac.id === reducer.accountPlans.activePlanId)
})

export default connect(mapStateToProps, null)(InvoiceStatus)



// WEBPACK FOOTER //
// ./src/app/elements/InvoiceStatus/index.js